
import React from "react";
import { Panel, Accordion, AccordionPanel } from '@ronuse/norseu/core/panels';
import { Button } from '@ronuse/norseu/core/buttons';
import { Scheme, FilePreviewType } from "@ronuse/norseu/core/variables";
import { ObjUtils } from "@ronuse/norseu/utils";
import { FileInput } from "@ronuse/norseu/core/form";
import Helpers from "../../../utils/Helpers"

export class FileInputPage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    buildDocumentation() {
        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Basic</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <FileInput scheme={Scheme.PRIMARY}
                                defaultFileUrl={"/assets/media/luffy.jpeg"}
                                fileExtensions={["png", "jpg", "jpeg", "JPG", "PNG", "JPEG"]}
                                label={"Select"}
                                previewType={FilePreviewType.IMAGE}/>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Preview Types</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div className="fi-preview-type-container">
                                <div>
                                    <p className="documentation-p">
                                        FilePreviewType.NONE
                                    </p>
                                    <FileInput scheme={Scheme.PRIMARY} style={{ minWidth: "200px", minHeight: "200px" }}
                                        previewType={FilePreviewType.NONE}/>
                                </div>

                                <div>
                                    <p className="documentation-p">
                                        FilePreviewType.IMAGE
                                    </p>
                                    <FileInput scheme={Scheme.PRIMARY} previewItemScheme={Scheme.PRIMARY}
                                        previewItemStyle={{ borderRadius: "100px" }}
                                        defaultFileUrl={"/assets/media/zoro.jpeg"}
                                        fileExtensions={["png", "jpg", "jpeg"]}
                                        label={"Select"}
                                        previewType={FilePreviewType.IMAGE} multiple noBorder/>
                                        <span>Click to select new image(s)</span>
                                </div>

                                <div>
                                    <p className="documentation-p">
                                        FilePreviewType.VIDEO
                                    </p>
                                    <FileInput scheme={Scheme.PRIMARY} previewItemScheme={Scheme.SECONDARY}
                                        defaultFileUrl={"/assets/media/Jerry_is_a_loser.mp4"}
                                        fileExtensions={["mp4", "mpeg", "mov"]}
                                        label={"Select"}
                                        previewType={FilePreviewType.VIDEO} multiple noBorder/>
                                        <span>Click to select new video(s)</span>
                                </div>

                                <div>
                                    <p className="documentation-p">
                                        FilePreviewType.AUDIO
                                    </p>
                                    <FileInput scheme={Scheme.PRIMARY}
                                        defaultFileUrl={"/assets/media/stomp_logo_3_13783.mp3"}
                                        fileExtensions={["mp3", "wav"]}
                                        label={"Select"}
                                        previewType={FilePreviewType.AUDIO} multiple noBorder/>
                                        <span>Click to select new audio(s)</span>
                                </div>

                                <div>
                                    <p className="documentation-p">
                                        FilePreviewType.PDF
                                    </p>
                                    <FileInput scheme={Scheme.PRIMARY} previewItemScheme={Scheme.SECONDARY}
                                        defaultFileUrl={"/assets/media/javascript_tutorial.pdf"}
                                        fileExtensions={["pdf"]}
                                        label={"Select"}
                                        previewType={FilePreviewType.PDF} multiple noBorder/>
                                        <span>Click to select new pdf(s)</span>
                                </div>

                                <div>
                                    <p className="documentation-p">
                                        FilePreviewType.TEXT
                                    </p>
                                    <FileInput scheme={Scheme.PRIMARY} previewItemScheme={Scheme.SECONDARY}
                                        defaultFileUrl={"/assets/media/wiki.txt"}
                                        fileExtensions={["txt", "js", "h", "c", "cpp"]}
                                        label={"Select"}
                                        previewType={FilePreviewType.TEXT} multiple noBorder/>
                                        <span>Click to select new text file(s)</span>
                                </div>

                                <div>
                                    <p className="documentation-p">
                                        FilePreviewType.BINARY
                                    </p>
                                    <FileInput scheme={Scheme.PRIMARY}
                                        defaultFileUrl={"/assets/media/javascript_tutorial.pdf"}
                                        previewType={FilePreviewType.BINARY} multiple noBorder/>
                                        <span>Click to select any file(s)</span>
                                </div>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Template</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <div style={{ border: "1px solid #dbdbdb", borderRadius: 5 , width: "100%" }}>
                                <div style={{ background: "#f5f5f5", borderBottom: "1px solid #dbdbdb" }}>
                                    <Button scheme={Scheme.PRIMARY} text="Choose" icon="fa fa-plus" onClick={() => this.templateInputRef.click()} disabled={this.state.uploading}/>
                                    <Button scheme={Scheme.PRIMARY} text="Upload" icon={!this.state.uploading ? "fa fa-upload" : "fa fa-spinner fa-spin"} 
                                        ref={(r) => this.uploadButton = r} onClick={() => {
                                        this.setState({ uploading: true });
                                        let timer = setInterval(() => {
                                            this.setState({ uploading: false });
                                            this.templateInputRef.clear();
                                            clearInterval(timer);
                                        }, 3000);
                                    }} disabled={this.state.uploading || !this.state.selectedFiles.length}/>
                                    <Button scheme={Scheme.DANGER} text="Cancel" icon="fa fa-times" onClick={() => {
                                        this.templateInputRef.clear();
                                    }} disabled={this.state.uploading || !this.state.selectedFiles.length}/>
                                </div>
                                <FileInput ref={(r) => this.templateInputRef = r} scheme={Scheme.PRIMARY} style={{ width: "100%", minHeight: 200 }}
                                    previewType={FilePreviewType.CUSTOM} 
                                    idleState={<div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", flexDirection: "column", marginTop: 30 }}>
                                        <i className="fa fa-image" aria-hidden="true" style={{ fontSize: 100 }}></i>
                                        <span style={{ marginTop: 10 }}>Drag and Drop images/videos here</span>
                                    </div>}
                                    customItemTemplate={(file, removeEvent) => {
                                        return <div disabled key={file.name} style={{ margin: 10, display: "flex", alignItems: "center", width: "100%", justifyContent: "space-between" }}>
                                            {file.type.includes("image") 
                                                ? <img src={file.url} style={{ width: 150, height: 120 }}/>
                                                : <video style={{ width: 150, height: 120 }} controls><source src={file.url}/></video>}
                                            <span>{file.name}</span>
                                            <span>{ObjUtils.humanFileSize(file.size)}</span>
                                            <Button scheme={Scheme.DANGER} icon="fa fa-times" onClick={() => removeEvent(file.name)} disabled={this.state.uploading} textOnly/>
                                        </div>
                                    }}
                                    onSelectedFilesChanged={(event) => {
                                        this.setState({ selectedFiles: event.files });
                                    }}
                                    fileExtensions={["png", "jpg", "jpeg", "mp4", "mpeg", "mov"]}
                                    disablePreviewClick allowFileDrag multiple noBorder/>
                            </div>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "FileInput",
            import_statement: "import { FileInput } from '@ronuse/norseu/core/form'",
            properties: this.properties,
            css_map: this.cssMap,
            ref_map: this.refMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/form/FileInputPage.js"
        });
    }

    state = {
        pageSource: '',
        showSourceDialog: false,
        uploading: false,
        selectedFiles: []
    }
    cssMap = [

    ];
    properties = [
        { name: "scheme", type: <a href='#/p/components/core/variables/scheme'>Scheme</a>, default: "null", description: "Set the file input appearance according to scheme" },
        { name: "id", type: "string", default: null, description: "Set the internal element id" },
        { name: "name", type: "string", default: null, description: "Set the internal input (type file[]) element name" },
        { name: "label", type: "string|element", default: null, description: "The clickable label in the file input that triggers file selection" },
        { name: "fileExtensions", type: "array", default: null, description: "Array of file extension(s) supported by the file picker" },
        { name: "previewType", type: <a href='#/p/components/core/variables/filepreviewtype'>FilePreviewType</a>, default: <a href='#/p/components/core/variables/filepreviewtype#image'>FilePreviewType.IMAGE</a>, description: "The preview type that determines how selected file(s) is previewed" },
        { name: "className", type: "string", default: null, description: "CSS classes to apply to the component" },
        { name: "style", type: "object", default: null, description: "CSS Style to apply to the component" },
        { name: "previewPanelClassName", type: "string", default: null, description: "CSS classes to apply to the preview panel component" },
        { name: "previewPanelStyle", type: "object", default: null, description: "CSS Style to apply to the preview panel component" },
        { name: "previewItemScheme", type: <a href='#/p/components/core/variables/scheme'>Scheme</a>, default: null, description: "Set the file preview item appearance according to scheme" },
        { name: "previewItemClassName", type: "string", default: null, description: "CSS classes to apply to the preview panel item component" },
        { name: "previewItemStyle", type: "object", default: null, description: "CSS Style to apply to the preview panel item component" },
        { name: "elementRef", type: "object", default: null, description: "Set a custom ref to use for the internal input element" },
        { name: "defaultFileUrl", type: "string", default: null, description: "Set the default file url to preview if no file(s) selected" },
        { name: "disablePreviewClick", type: "boolean", default: false, description: "If set to true clicking the preview panel will not trigger ther file picker" },
        { name: "multiple", type: "boolean", default: false, description: "Toggle file picker ability to select multiple or single file(s)" },
        { name: "noBorder", type: "boolean", default: false, description: "Set or remove the border of the file input" },
        { name: "allowFileDrag", type: "boolean", default: false, description: "Allow dragging file(s) from system to the input component" },
        { name: "customItemTemplate", type: "function", default: "(files, removeEvent)", description: "Render custom react element for the preview items" },
        { name: "idleState", type: "ReactElement", default: null, description: "The React element to render when no file(s) is selected" },
        { name: "onFilesSelected", type: "function", default: "(event)", description: "The callback that is invoked when new file(s) are selected" },
        { name: "onFilesCleared", type: "function", default: "(event)", description: "The callback that is invoked when the selected files has been cleared" },
        { name: "onCompleteDialog", type: "function", default: "(event)", description: "The callback that is invoked after file is selected with the file picker dialog" },
        { name: "onCancelDialog", type: "function", default: "(event)", description: "The callback that is invoked the file picker dialog cancel button is clicked" },
        { name: "onSelectedFilesChanged", type: "function", default: "(event)", description: "The callback that is invoked when the selected file(s) is removed or added. Invoke along with onFilesSelected, onFilesCleared" },
    ];
    refMap = [
        { name: "clear(e)", type: "function", description: "Clear all the selected file and remove from preview" },
        { name: "click(e)", type: "function", description: "Trigger the file input element to select file(s)" },
        { name: "values()", type: "function", description: "Get the selected files" },
        { name: "value()", type: "function", description: "Get the first selected file" },
        { name: "changePreview(files)", type: "function", description: "Change the elements that is rendered in the preview panel. Each file must have the following field, url, name, size, type" },
        { name: "focus()", type: "function", description: "Send focus to the component" },
        { name: "getInternalElement()", type: "function", description: "Get the react reference to the internal element" },
        { name: "getState()", type: "function", description: "Get the current state of the component" },
        { name: "setState(newState)", type: "function", description: "Change the component state" },
    ]

}